import * as React from "react";
import styled from "styled-components";
const RemindMe = styled.section `
	width: ${(props) => props.bWidth};
	height: ${(props) => props.bHeight};
	font-size: 0.8125rem;
	line-height: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 2px;
	background: linear-gradient(134deg, rgba(107, 159, 247, 1) 0%, rgba(17, 102, 247, 1) 100%);
	color: #fff;
	font-family: var(--fontRegular);
	font-weight: 400;
`;
const Cancel = styled.div `
	width: ${(props) => props.bWidth};
	height: ${(props) => props.bHeight};
	font-size: 0.8125rem;
	line-height: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 2px;
	border: 1px solid;
	color: #3d82f7;
	font-family: var(--fontRegular);
	font-weight: 400;
`;
const ComingSoon = styled.div `
	width: ${(props) => props.bWidth};
	height: ${(props) => props.bHeight};
	font-size: 0.8125rem;
	line-height: 1rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 2px;
	background: linear-gradient(134deg, rgba(107, 159, 247, 1) 0%, rgba(17, 102, 247, 1) 100%);
	color: #fff;
	font-family: var(--fontRegular);
	font-weight: 400;
`;
class RemindMeBtn extends React.Component {
    constructor() {
        super(...arguments);
        this.remindMe = (e) => {
            const { remindRightBtn } = this.props;
            remindRightBtn();
            e.stopPropagation();
        };
    }
    render() {
        const { bWidth, bHeight, isRemindMe, isInApp } = this.props;
        if (isInApp) {
            if (isRemindMe) {
                return (React.createElement(Cancel, { bWidth: bWidth, bHeight: bHeight, onClick: e => this.remindMe(e) }, "Cancel"));
            }
            return (React.createElement(RemindMe, { bWidth: bWidth, bHeight: bHeight, onClick: e => this.remindMe(e) }, "Remind Me"));
        }
        return (React.createElement(ComingSoon, { bWidth: bWidth, bHeight: bHeight }, "Coming Soon"));
    }
}
export default RemindMeBtn;
